import React from "react";
import { Box, Button, Container, Paper, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../api/auth";
import { useSnack } from "../services/SnakbarProvider";
import { handleError } from "../services/errorHandler";

const validationSchema = Yup.object({
  email: Yup.string().email("Ingresa un email válido").required("El email es requerido"),
});

export default function ForgotPasswordPage() {
  const { openSnack } = useSnack();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await forgotPassword(values.email);
        openSnack(
          "Se ha enviado un correo con las instrucciones para restablecer tu contraseña",
          "success"
        );
        navigate("/login");
      } catch (e) {
        openSnack(handleError(e), "error");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Paper sx={{ p: 4 }}>
        <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
          Reestablecer contraseña
        </Typography>
        <Box component="form" onSubmit={formik.handleSubmit}>
          <TextField
            required
            fullWidth
            margin="normal"
            id="email"
            name="email"
            label="Email"
            autoComplete="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={formik.isSubmitting}
            sx={{ mt: 3 }}
          >
            Enviar instrucciones
          </Button>
          <Button
            fullWidth
            variant="text"
            onClick={() => navigate("/login")}
            sx={{ mt: 1 }}
          >
            Volver al inicio de sesión
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
